<template>
  <v-card class="affiliate-creating-links-list-main-block">
    <v-card-title class="affiliate-creating-links-list-title">
      {{ $t('affiliateProgram.links.listOfCreatedLinks') }}
    </v-card-title>
    <v-list class="affiliate-creating-links-list-items">
      <v-list-item
        v-for="(item, index) in createdLinksList"
        :key="index"
        class="affiliate-creating-links-list-item"
      >
        <v-list-item-content class="affiliate-creating-links-list-item-content">
          <star-outline-icon
            v-if="index === 0"
            class="affiliate-creating-links-list-item-star-icon"
          />
          <span class="affiliate-creating-links-list-item-name">
            {{ itemSource(item) }}
          </span>
        </v-list-item-content>
        <v-list-item-action class="ma-0 affiliate-creating-links-list-item-actions">
          <v-tooltip
            :value="copiedItem === item.id"
            top
            class="affiliate-creating-links-list-item-action-tooltip"
          >
            <template #activator="{ }">
              <v-btn
                class="affiliate-creating-links-list-item-action-copy-btn"
                icon
                @click="showCopiedTooltip(item)"
              >
                <copy-outline-icon class="affiliate-creating-links-list-item-action-copy-icon" />
              </v-btn>
            </template>
            <span class="affiliate-creating-links-list-tooltip-text">
              {{ $t('common.copied') }}
            </span>
          </v-tooltip>
          <v-btn
            :disabled="index === 0"
            class="affiliate-creating-links-list-item-action-delete-btn"
            icon
            @click="openLinkDeleteDialog(item)"
          >
            <delete-outline-icon class="affiliate-creating-links-list-item-action-delete-icon" />
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-pagination
      v-if="pagination.lastPage > 1"
      :value="pagination.currentPage"
      :length="pagination.lastPage"
      :total-visible="pagination.perPage"
      class="mt-0 custom-pagination"
      color="unset"
      @next="handleGetCreatingLinks(pagination.currentPage + 1)"
      @previous="handleGetCreatingLinks(pagination.currentPage - 1)"
      @input="handleGetCreatingLinks($event)"
    />
  </v-card>
</template>

<script>
import StarOutlineIcon from '@/assets/svgIcons/starOutline.svg?inline'
import CopyOutlineIcon from '@/assets/svgIcons/copyOutline.svg?inline'
import DeleteOutlineIcon from '@/assets/svgIcons/deleteOutline.svg?inline'
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  name: 'AffiliateCreatingLinksList',
  components: {
    StarOutlineIcon,
    CopyOutlineIcon,
    DeleteOutlineIcon
  },
  data: () => ({
    copiedItem: null
  }),
  computed: {
    ...mapGetters({
      profile: 'main/profile',
      pagination: 'affiliate/createdLinksListPagination',
      createdLinks: 'affiliate/createdLinksList',
    }),
    createdLinksList () {
      return [
        {
          id: '',
          isMainLink: true,
          source: `${location.origin}/a/${this.profile.id}/`
        },
        ...this.createdLinks
      ]
    }
  },
  created() {
    this.getCreatingLinks()
  },
  methods: {
    ...mapActions({
      openDialog: 'main/openDialog',
      setLinkForDeleting: 'affiliate/setLinkForDeleting',
      getCreatingLinks: 'affiliate/getCreatingLinks',
    }),
    itemSource(item) {
      if (item.isMainLink) {
        return item.source
      }

      return `${location.origin}/a/${this.profile.id}/${item.source}`
    },
    showCopiedTooltip(item) {
      try {
        const link = item.isMainLink ? item.source : `${location.origin}/a/${this.profile.id}/${item.source}`

        navigator.clipboard.writeText(link)

        this.copiedItem = item.id

        setTimeout(() => {
          this.copiedItem = null
        }, 300);
      } catch (err) {
        console.error(err)
      }
    },
    async openLinkDeleteDialog(item) {
      await this.setLinkForDeleting(item.id)
      this.openDialog('affiliateDialogDeleteLinks')
    },
    handleGetCreatingLinks(selectedPage) {
      if (selectedPage < 1 || selectedPage > this.pagination.lastPage) return;

      this.getCreatingLinks(selectedPage)
    }
  },
};
</script>

<style scoped>
.affiliate-creating-links-list-main-block,
.affiliate-creating-links-list-main-block.v-sheet.v-card:not(.v-sheet--outlined) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: unset;
  margin-bottom: 32px;
}
.affiliate-creating-links-list-title,
.affiliate-creating-links-list-title.v-card__title {
  color: var(--v-text-primary-base);
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  padding: 0;
  letter-spacing: 0;
}
.affiliate-creating-links-list-items {
  width: 100%;
}
.affiliate-creating-links-list-items .affiliate-creating-links-list-item {
  display: flex;
  padding: 4px 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--v-border-primary-base);
}
.affiliate-creating-links-list-item-content,
.affiliate-creating-links-list-item-content.v-list-item__content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex: 9;
  padding: 0;
  overflow: unset;
  column-gap: 8px;
  line-break: anywhere;
}
.affiliate-creating-links-list-items .affiliate-creating-links-list-item-name:first-child {
  font-weight: 400;
}
.affiliate-creating-links-list-item .affiliate-creating-links-list-item-name {
  color: var(--v-text-primary-base);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.affiliate-creating-links-list-item-action-copy-btn,
.affiliate-creating-links-list-item-action-delete-btn {
  margin: auto;
}
.affiliate-creating-links-list-item .affiliate-creating-links-list-item-actions,
.affiliate-creating-links-list-item .affiliate-creating-links-list-item-actions.v-list-item__action--stack {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: end;
  gap: 8px;
}
.affiliate-creating-links-list-item-action-delete-btn.v-btn--disabled .affiliate-creating-links-list-item-action-delete-icon{
  color: #959199;
}
.affiliate-creating-links-list-item-action-delete-icon {
  max-width: max-content;
  color: #19181A;
}
.affiliate-creating-links-list-item-star-icon,
.affiliate-creating-links-list-item-action-copy-icon {
  max-width: max-content;
  color: #B645EE;
}
</style>
